import {
  CFormCheck,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useQueryClient, useMutation } from "react-query";
import { useToast } from "../../../hooks/useToast";
import { useCookie } from "../../../hooks/useCookie";
import apiService from "../../../service/apiService";
import { DELETE_ACTIONS } from "../../../config/constants";
import { general } from "../../../locales/general";
import { colors } from "../../../config/theme";
import EditIcon from "../../../components/icons/EditIcon";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PromptModal from "../../../components/modals/PromptModal";
import { Link } from "react-router-dom";

function TableBodyRowContent({
  packTranslation,
  deletedList,
}: {
  packTranslation: PackTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deletePackTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`pack-translations/${id}`, token);
  });

  useEffect(() => {
    if (isChecked) {
      deletedList({ type: DELETE_ACTIONS.ADD, id: packTranslation.id });
    } else {
      deletedList({ type: DELETE_ACTIONS.REMOVE, id: packTranslation.id });
    }
  }, [deletedList, isChecked, packTranslation.id]);

  const removePackTranslation = () => {
    deletePackTranslation.mutate(packTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className=" text-capitalize text-sm">
        <div className="d-flex align-items-center gap-3">
          <CFormCheck
            id="flexCheckDefault"
            label=""
            defaultChecked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color={colors.yellow}
          />

          <img
            src={packTranslation.pack?.image}
            alt=""
            width={30}
            height={30}
            style={{ borderRadius: "100%" }}
          />

          <div>{packTranslation.pack?.title}</div>
        </div>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{packTranslation?.title}</span>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{packTranslation?.lang}</span>
      </CTableDataCell>

      <CTableDataCell>
        <Link to={`/pack-translations/update/${packTranslation.id}`}>
          <EditIcon width="18" height="18" fill={colors.secondary} />
        </Link>{" "}
        <button
          className="outline-none border-0 bg-transparent"
          onClick={() => setShowModal(true)}
        >
          {deletePackTranslation.isLoading ? (
            <CSpinner size="sm" />
          ) : (
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          )}
        </button>
      </CTableDataCell>
      <PromptModal
        open={showModal}
        onAccept={removePackTranslation}
        onClose={() => setShowModal(false)}
      />
      {/* <PackTranslationModal
                onClose={() => setShowEditModal(false)}
                open={showEditModal}
                id={packTranslation?.id}
                name={packTranslation?.name}
                link={packTranslation?.link}
                logo={packTranslation?.logoImage}
            /> */}
    </CTableRow>
  );
}

interface TableProps {
  packTranslations: PackTranslation[];
  packTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function PackTranslationsTable({
  packTranslations,
  packTranslationsToBeDeleted,
}: TableProps) {
  return (
    <div className="mt-3">
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Pack</CTableHeaderCell>
            <CTableHeaderCell scope="col">Traduction</CTableHeaderCell>
            <CTableHeaderCell scope="col">Langue</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {packTranslations?.map((packTranslation) => (
            <TableBodyRowContent
              packTranslation={packTranslation}
              key={packTranslation?.id}
              deletedList={packTranslationsToBeDeleted}
            />
          ))}{" "}
        </CTableBody>
      </CTable>
    </div>
  );
}
